$(document).ready(function () {
    $('.carousel-loop').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      arrows: false,
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      waitForAnimate: false,
      swipe: false,
      draggable: false,
      variableWidth: true,
    
      
      responsive: [
        {
          breakpoint: 767,
          settings: {
            speed: 8000,
          }
        }
      ]
    });
  });